import { prefixerM } from '.'

export const ROUTE_CREAR_CAJA_CHICA = prefixerM('crear-caja-chica')
export const ROUTE_CREAR_TIPO_GASTO = prefixerM('crear-tipo-gasto')
